import React from 'react'
import Star from 'components/svg/Star'
import i from 'i18next'

export const getAverage = ( reviews ) => (
	reviews
		.map( review => review.rating )
		.reduce( ( a, b ) => a + b, 0 )
		/ reviews.length
)

type Props = {
	big?: boolean
	rating: number
	count: number
}

export default function Rating({ big, rating, count }: Props ) {
	return (
		<div className="rating">
			<div
				aria-label={i.t(
					'product.rating.aria',
					{ rating: Math.round( rating * 10 ) / 10 }
				)}>
				<Star size={big ? 18 : undefined} filled={Math.min( rating - 0, 1 )} />
				<Star size={big ? 18 : undefined} filled={Math.min( rating - 1, 1 )} />
				<Star size={big ? 18 : undefined} filled={Math.min( rating - 2, 1 )} />
				<Star size={big ? 18 : undefined} filled={Math.min( rating - 3, 1 )} />
				<Star size={big ? 18 : undefined} filled={Math.min( rating - 4, 1 )} />
			</div>
			<span className="count">
				{i.t( 'product.review.count', { count })}
			</span>
			<span className="count-short">
				{count}
			</span>
			<style jsx>{`
				.rating {
					display: flex;
					white-space: nowrap;
					color: #939aa0;
					font-size: ${big ? '18px' : '15px'};
					font-weight: normal;
				}
				.rating > div {
					margin-right: 10px;
				}
				.rating svg {
					margin-top: 4px;
					margin-right: 3px;
				}
				.count {
					line-height: 1.3;
				}
				.count-short {
					display: none;
				}
			`}</style>
		</div>
	)
}
